import { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import Box from '@/design_system/Box';
import Stack from '@/design_system/Stack';
import { type Product, useUpdateProduct } from '@/models/product';
import {
  EditButton,
  SaveCancelButtons,
} from '@/routes/SettingsBeta/components/SaveEditCancelButtons';

import { Brand } from './Brand';

export const BrandSection = ({ product }: { product: Product }) => {
  const { t } = useLingui();
  const { mutateAsync: updateProduct, isPending: isUpdateProductPending } = useUpdateProduct(
    product.id
  );
  const [isEditing, setIsEditing] = useState(false);
  const [brandId, setBrandId] = useState<string | null>(product.brandId);

  const handleSave = async () => {
    setIsEditing(false);

    await updateProduct({ brandId });
  };

  const handleCancel = () => {
    setBrandId(product.brandId);
    setIsEditing(false);
  };

  return (
    <Box>
      <Stack row justifyContent="space-between">
        <Brand product={product} isEditing={isEditing} brandId={brandId} setBrandId={setBrandId} />

        {isEditing ? (
          <SaveCancelButtons
            onSave={handleSave}
            onCancel={handleCancel}
            isSaving={isUpdateProductPending}
          />
        ) : (
          <EditButton
            label={t({
              id: 'settings.organization.data-catalogs.products.product.brand-section.edit',
              message: 'Edit product brand',
            })}
            onClick={() => setIsEditing(true)}
          />
        )}
      </Stack>
    </Box>
  );
};
